import { useState, useEffect } from 'react';

import { BasicRound } from '@lcsc-design/utils/decimal';
import { InputNumber, Popover } from 'antd';

export default function DialogRight({ row, setParentValue }) {
  const [minNumberTipText, setMinNumberTipText] = useState(false);
  const [isOpenMinNumberTips, setIsOpenMinNumberTips] = useState(false);
  const [catInputNum, setCatInputNum] = useState(
    row?.productMinEncapsulationNumber ? row?.productMinEncapsulationNumber : 1
  );
  const [wholeInputNum, setWholeInputNum] = useState(null);
  const [totalMoney, setTotalMoney] = useState(null);
  // const [encapsulationNum, setEncapsulationNum] = useState(null);
  const [minNum, setMinNumber] = useState(BasicRound(row?.productPriceList[0]?.productPrice || 0, 6));
  const ratio = row?.ratio == 0 ? 1 : row?.ratio || 1;
  const productPriceList = row?.productPriceList || row?.productDiscountPriceList;
  let selectNum = 1;

  useEffect(() => {
    getPrice();
  }, []);

  const amendNum = () => {
    const num = catInputNum * selectNum;
    if (catInputNum < row?.productMinEncapsulationNumber) {
      setIsOpenMinNumberTips(true);
      setCatInputNum(row?.productMinEncapsulationNumber);
      getPrice(row?.productMinEncapsulationNumber);
      setMinNumberTipText(`最小起订量为${row?.productMinEncapsulationNumber}，已为您修正。`);
      setTimeout(() => setIsOpenMinNumberTips(false), 1000);
    } else if (num % ratio != 0) {
      setIsOpenMinNumberTips(true);
      setMinNumberTipText(`必须以${ratio}的倍数购买，已为您修正。`);
      setTimeout(() => setIsOpenMinNumberTips(false), 1000);
      setCatInputNum(Number(ratio) * Math.ceil(num / ratio));
    }
  };
  const getPrice = (e) => {
    // 获取对应数量价格
    let price = minNum;
    if (productPriceList?.length > 0) {
      productPriceList?.forEach((v) => {
        if (
          v.startPurchasedNumber * ratio <= (e || catInputNum) &&
          (v.endPurchasedNumber * ratio >= (e || catInputNum) || v.endPurchasedNumber == -1)
        ) {
          price = v.productPrice;
        }
      });
    }
    setMinNumber(price);
    const total = ((e || catInputNum) * price).toFixed(2);
    setTotalMoney(total);
  };
  const changeNumber = (e) => {
    setCatInputNum(e);
    getPrice(e);
    setParentValue(e);
    if (row?.productMinEncapsulationNumber === 1) {
      setWholeInputNum(e);
    }
  };

  const changeWholeNumber = (e) => {
    selectNum = e;
    setWholeInputNum(e);
    if (row?.productMinEncapsulationNumber) {
      setCatInputNum(e * row?.productMinEncapsulationNumber);
      getPrice(e * row?.productMinEncapsulationNumber);
      setParentValue(e * row?.productMinEncapsulationNumber);
    } else {
      getPrice(e);
    }
  };

  const blurNumber = (e) => {
    // setEncapsulationNum(e);
    amendNum(e.target.value);
  };

  const priceList = productPriceList?.map((item, index) => (
    <li key={index} className="mb-[16px] flex justify-center text-[12px]">
      <span className="flex-1 inline-block w-[52px] text-right text-[#000000]">
        {item?.startPurchasedNumber * ratio} +
      </span>
      <span className="flex-1 text-[#FF4960] text-left inline-block pl-[16px]">
        ￥{item?.productPrice || item.price}
      </span>
    </li>
  ));

  return (
    <div className="flex-1">
      <div className="text-center mb-[16px]">
        <p className="mb-[16px] text- [#54657D]">含增值税</p>
        {productPriceList?.length &&
          (productPriceList?.length === 1 ? (
            <div className="mt-[16px]">
              单价：
              <span className="text-[#FF4960]">
                ￥{row?.productPriceList[0].productPrice || row?.productPriceList[0].price} /
                {row?.productUnit || row?.venditionUnit}
              </span>
            </div>
          ) : (
            <ul>{priceList}</ul>
          ))}
      </div>
      <div className="mb-[16px] mt-[22px]">
        <span>
          购买数量：
          <Popover content={minNumberTipText} open={isOpenMinNumberTips}>
            <InputNumber
              controls={false}
              size="mini"
              value={catInputNum}
              min={0}
              precision={0}
              className="w-[100px] mr-[10px]"
              onChange={(e) => {
                changeNumber(e);
              }}
              onBlur={(e) => {
                blurNumber(e);
              }}
              maxLength={8}
            />
          </Popover>
          × <span className="text-[#FF4960]">￥{minNum} </span> = <span className="text-[#FF4960]">￥{totalMoney}</span>
        </span>
      </div>
      {row?.productMinEncapsulationUnit && (
        <div>
          按整包装：
          <InputNumber
            controls={false}
            value={wholeInputNum}
            className="w-[100px]"
            onChange={(e) => {
              changeWholeNumber(e);
            }}
            onBlur={(e) => {
              blurNumber(e);
            }}
            maxLength={8}
          />
          <span className="ml-[5px] inline-block">{row?.productMinEncapsulationUnit}</span> (
          {`${row?.productMinEncapsulationNumber}${row?.productUnit}/${row?.productMinEncapsulationUnit}`})
        </div>
      )}
    </div>
  );
}
